import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SortControl from '../SortControl';
import MemberRow from './MemberRow';
import { memberPropertiesType, membersType, sortingParamType } from '../../types';
import './_styles_/MembersList.css';

MembersList.propTypes = {
    members: membersType.isRequired,
    onSort: PropTypes.func.isRequired,
    memberProps: memberPropertiesType.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function MembersList(props) {
    const {
        members,
        onSort,
        sortingParam,
        memberProps,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="members-list">
            <div className="rich-list-row rich-list-header members-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="member-header--values--name">
                    <SortControl sortingKey="name" sortingParam={sortingParam} onChange={onSort}>
                        {t('members.list-header.name')}
                    </SortControl>
                </div>
                {memberProps.availableProductTypes.includes('ENERGY') && (
                    <div className="member-header--values--balancing-group">
                        <SortControl sortingKey="balancingGroup" sortingParam={sortingParam} onChange={onSort}>
                            {t('members.list-header.balancing-group')}
                        </SortControl>
                    </div>
                )}
                {memberProps.availableMemberTypes.length > 1 && (
                    <div className="member-header--values--member-type">
                        <SortControl sortingKey="memberType" sortingParam={sortingParam} onChange={onSort}>
                            {t('members.list-header.member-type')}
                        </SortControl>
                    </div>
                )}
                <div className="member-header--values--member-id">
                    <SortControl sortingKey="memberId" sortingParam={sortingParam} onChange={onSort}>
                        {t('members.list-header.member-id')}
                    </SortControl>
                </div>
                <div className="member-header--values--suspended">
                    <SortControl sortingKey="suspended" sortingParam={sortingParam} onChange={onSort}>
                        {t('members.list-header.suspended')}
                    </SortControl>
                </div>
                <div className="member-header--values--active">
                    <SortControl sortingKey="active" sortingParam={sortingParam} onChange={onSort}>
                        {t('members.list-header.active')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                members.length
                    ? members.map((member) => <MemberRow member={member} key={member.memberId} memberProps={memberProps} />)
                    : (<div className="members-no-items">{t('members.no-items')}</div>)
            }
        </div>
    );
}

export default MembersList;
